import React from 'react';
import { FormattedMessage } from '../../../../plugins/publicis-gatsby-plugin-i18n';

import { AccessibiliteIcon } from '../../../Atoms/Icons/Icons';
import Languages from '../../Languages/Languages';

import './HeaderTop.scss';

const HeaderTop = () => {

  const onShowAccessibilite = (e) => {
    e.preventDefault();
    document.body.classList.add('show_accessibility_popin');
    if (document.querySelectorAll('.popin_accessibilite .label_btn')?.length > 0) {
      document.querySelectorAll('.popin_accessibilite .label_btn')[0]?.focus();
    }
  };

  return (
    <div className="headerTop">
      <div className="custom_wrapper">
        <div className="right_elem">
          <a href="#" className="accessibilite" onClick={(e) => onShowAccessibilite(e)}>
            <AccessibiliteIcon />
            <FormattedMessage id="accessibility.title" />
          </a>
          <Languages />
        </div>
      </div>
    </div>
  );
};

export default HeaderTop;
